///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Routes } from '@angular/router';
import { GtthProjectViewComponent } from './project-view.component';
import { UserAuthorities } from '../services/user/user-authorities';
import { canActivateUser } from '../shared/auth/user-route-access-service';

export const projectViewRoute: Routes = [
    {
        path: 'project-view/:id',
        component: GtthProjectViewComponent,
        data: {
            authorities: UserAuthorities.PROJECT_ALL,
            pageTitle: 'project.home.title'
        },
        canActivate: [canActivateUser],
        canDeactivate: [(component: GtthProjectViewComponent) => !component.isProjectOpeningInProgress()],
        title: 'Project'
    }
];
